<template>
    <div class="editable-toggle">
        <label class="switch">
            <input type="checkbox" v-model="toggleData">
            <span class="slider round"></span>
            <div class="editable-toggle__text" :class="{'editable-toggle__text--active' : toggleData}">
                <span v-if="toggleData">{{translate('Page1.text20')}}</span>
                <span v-else>{{translate('Page1.text21')}}</span>
            </div>
        </label>

    </div>
</template>

<script>
    export default {
        name: "editableToggle",
        data: ()=>{
            return {
                isVisible: false
            }
        },
        computed:{
            toggleData:{
                get(){
                    return this.$store.state.editMode;
                },
                set(value){
                    this.$store.commit('setEditMode', value);
                    this.$emit('on-scenario-editable');
                    
                    if(localStorage) {
                        localStorage.setItem('editMode', value)
                    }
                }
            }

        }
    }
</script>

<style lang="less" scoped>
    .editable-toggle {
        position: absolute;
        right: -70px;
        top: 20px;
        &__text {
            position: absolute;
            left: 75px;
            top: 5px;
            color: #9d9f9e;
            transition: color 500ms;
            cursor: pointer;
            &--active {
                color: #2196F3;
            }
        }
    }

    .switch {
        position: relative;
        display: inline-block;
        width: 60px;
        height: 34px;
    }

    /* Hide default HTML checkbox */
    .switch input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    /* The slider */
    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #ccc;
        -webkit-transition: .4s;
        transition: .4s;
    }

    .slider:before {
        position: absolute;
        content: "";
        height: 26px;
        width: 26px;
        left: 4px;
        bottom: 4px;
        background-color: white;
        -webkit-transition: .4s;
        transition: .4s;
    }

    input:checked + .slider {
        background-color: #2196F3;
    }

    input:focus + .slider {
        box-shadow: 0 0 1px #2196F3;
    }

    input:checked + .slider:before {
        -webkit-transform: translateX(26px);
        -ms-transform: translateX(26px);
        transform: translateX(26px);
    }

    /* Rounded sliders */
    .slider.round {
        border-radius: 34px;
    }

    .slider.round:before {
        border-radius: 50%;
    }
</style>
